import styled from 'styled-components';
import PlayNavigation from '../../ui-components/PlayNavigation/PlayNavigation';
import { PlayTabListItemLink } from '../../ui-components/PlayNavigation/PlayNavigation.styles';

export const PlayNavigationGenre = styled(PlayNavigation)`
    margin-bottom: 20px;

    ${PlayTabListItemLink} {
        font-size: 22px;
    }
`;
